import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";

import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { auxiliarData } from "../AuxiliarData";

export type PatientSummaryMhdEntryFilter =
  | "AllergyIntolerance"
  | "MedicationRequest"
  | "Procedure"
  | "Condition"
  | "Observation"
  | "DocumentReference"
  | "ServiceRequest"
  | "MedicationStatement"
  | "Immunization"
  | "CarePlan"
  | "QuestionnaireResponse";

interface IPatientSummary {
  identifier: string;
  /**
   * Tokens que filtram `request.url` via `includes`.
   * Aceita resourceTypes (ex.: "DocumentReference") ou trechos de URL
   * (ex.: category codes como "anvisa_import_authorization").
   */
  entries?: Array<PatientSummaryMhdEntryFilter | string>;
  purposeofuse?: string;
  /**
   * Prioriza o header organization-id quando o caller já conhece a org
   * (ex.: tela Ecommerce). Fallback: useAuth.getOrganizationId().
   */
  organizationId?: string;
}

export async function BundlePatientSummary({
  identifier,
  entries,
  purposeofuse,
  organizationId: organizationIdOverride,
}: IPatientSummary) {
  let url = `${endpoints.MHD}`;
  const data = auxiliarData.PatientSummary(identifier, entries);
  const subjectId = await useAuth.getSubjectId();
  const organizationId =
    organizationIdOverride?.trim() || (await useAuth.getOrganizationId());

  const headers = {
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
    Accept: "application/fhir+json",
    "x-user-token": await useAuth.getXUserToken(),
    ...(subjectId && { "subject-id": subjectId }),
    ...(organizationId && { "organization-id": organizationId }),
    purposeofuse: purposeofuse || "Atendimento",
  };

  const response = await useAxios
    .post(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`BundlePatientSummary: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      if (error?.response.status === HTTPResponseStatus.Forbidden) {
        return { status: HTTPResponseStatus.Forbidden };
      }

      console.error("BundlePatientSummary ", error);
      // toast.error(`BundlePatientSummary Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
